import React, { useEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import { type FeedFlowItem, type RichResource } from '@src/services/interface';

type SecondShareProps = {
    content: FeedFlowItem | null;
};

const SecondShare = ({ content }: SecondShareProps) => {
    const baseTitle = '我在天下事发现一篇有趣的文章';
    const contentInfo = content || {}; // 帖子主体信息
    const postInfo = contentInfo?.post;
    const type = contentInfo?.type || '';
    const userName = contentInfo?.author?.nickname ?? '';
    const defaultLogo =
        'https://x0.ifengimg.com/ucms/2022_38/B74A71CF8F41DAF00FFBD6F42D4E5E08FD5256B7_size7_w300_h300.png';

    let title = '';
    let desc = '';
    let thumbnail = '';

    if (contentInfo?.checkStatus == 1) {
        if (type === 'short') {
            const contentText = postInfo?.text?.content ?? '';
            title = contentText || baseTitle;

            thumbnail = postInfo?.images?.[0]?.url || defaultLogo;
            const existVote = postInfo?.hasVote == true && postInfo?.vote?.id != null;

            if (existVote) {
                desc = `来自${userName}发起的投票`;
            } else {
                desc = `来自${userName}的天下事推文`;
            }
        }

        if (type === 'translate') {
            try {
                const richResource: RichResource = (content?.richResource && JSON.parse(content?.richResource)) || {};

                desc = postInfo?.text?.content ?? '';
                title = contentInfo?.title ?? desc ?? baseTitle;
                thumbnail = richResource?.imageList?.[0]?.url || richResource?.videoList?.[0]?.posterImg || defaultLogo;
            } catch (e) {
                console.log(e);
            }
        }

        if (type === 'predict') {
            const richResource: RichResource = (content?.richResource && JSON.parse(content?.richResource)) || {};
            const unlock = contentInfo?.unlock || false;

            desc = contentInfo?.summary ?? '';
            title = contentInfo?.title ?? desc ?? baseTitle;

            if (unlock) {
                thumbnail = richResource?.imageList?.[0]?.url || richResource?.videoList?.[0]?.posterImg || defaultLogo;
            } else {
                thumbnail = defaultLogo;
            }
        }
    } else {
        title = baseTitle;
        desc = '';
        thumbnail = defaultLogo;
    }

    const qqShareCofig = {
        title,
        img: thumbnail,
        desc,
        appType: 'newsApp',
        cb: () => {},
    };

    useEffect(() => {
        document.title = title;
    }, [title]);

    // qqShareCofig.title不能为空，qqshare组件只能执行一次
    return qqShareCofig?.title ? <QQShare content={qqShareCofig} /> : null;
};

export default errorBoundary(SecondShare);
